import React from 'react';
import { lazyWithRetry } from '../../utils/lazyWithRetry';
import { AppRoute } from '../routes.types';

const SharePage = lazyWithRetry(() => import('../../venues/pages/SharePage/SharePage'));
const MyReferals = lazyWithRetry(() => import('../../containers/Referal/MyReferals'));
const Withdraw = lazyWithRetry(() => import('../../containers/Referal/Withdraw'));
const Donate = lazyWithRetry(() => import('../../containers/Referal/Donate'));
const CharityEdit = lazyWithRetry(() => import('../../containers/Referal/CharityEdit'));
const Charity = lazyWithRetry(() => import('../../containers/Referal/Charity'));
const PracticeRequests = lazyWithRetry(() => import('../../containers/PracticeRequests/PracticeRequests'));
const ReferralRequests = lazyWithRetry(() => import('../../containers/ReferralRequests/ReferralRequests'));

export const SHARE_ROUTES: AppRoute[] = [
    { path: '', element: <SharePage /> },
    { path: 'my-referrals', element: <MyReferals /> },
    { path: 'withdraw', element: <Withdraw type="user" /> },
    { path: 'charities', element: <Charity /> },
    { path: 'charities/:id/edit', element: <CharityEdit /> },
    { path: 'charities/:id/withdraw', element: <Withdraw type="charity" /> },
    { path: 'donate', element: <Donate type="donation" /> },
    { path: 'nonprofits', element: <Donate type="nonprofits" /> },
    { path: 'practice-requests', element: <PracticeRequests /> },
    { path: 'referral-requests', element: <ReferralRequests /> },
];
